// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".susQag21zWg4eX {\n  text-align: center;\n  margin-bottom: 12px;\n}\n.OPG2Yg2miaPQg6 {\n  margin-bottom: 0;\n}\n.o4Rv7T8d0Td9\\+Q {\n  flex: 1 1 auto;\n  z-index: 1;\n  min-height: 0;\n  padding-top: 1px;\n}\n.Mk4vPlDGFBF6Km {\n  display: flex;\n}\n.s4TUZcJhJ3uVJV {\n  width: 100%;\n  margin-bottom: 8px;\n  min-height: 56px;\n}\n.QWNKUCUk6H8uJS,\n.tlLf55gCgQ1wUs {\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n.OuhpNzrk1iyt5T {\n  text-decoration: none;\n}\n.RpAEaElqj7K6VH {\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n}\n.RpAEaElqj7K6VH ._6dYJ-uhKe7y\\+Lo {\n  width: 32px;\n  padding: 6px 8px;\n  margin-bottom: 8px;\n}\n.RpAEaElqj7K6VH ._6dYJ-uhKe7y\\+Lo:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyStateMessage": "susQag21zWg4eX",
	"createNewTemplateButton": "OPG2Yg2miaPQg6",
	"templateCards": "o4Rv7T8d0Td9+Q",
	"templateCardContainer": "Mk4vPlDGFBF6Km",
	"templateCard": "s4TUZcJhJ3uVJV",
	"editTemplatesButton": "QWNKUCUk6H8uJS",
	"finishEditingButton": "tlLf55gCgQ1wUs",
	"noTextDecoration": "OuhpNzrk1iyt5T",
	"controlButtons": "RpAEaElqj7K6VH",
	"controlButton": "_6dYJ-uhKe7y+Lo"
};
export default ___CSS_LOADER_EXPORT___;
